<template>
    <a-row class="mt" >
        <a-col :span="7">
            <a-select size="small" showSearch style="width: 100%;" v-model="flName" @change="flNameChange">
                <a-select-option
                        v-for="option in options.fieldNameSel"
                        :value="option.uid"
                >{{ option.key }}</a-select-option>
            </a-select>
        </a-col>
        <a-col :span="5" class="ml4" v-if="flName">
             <a-select size="small" disabled style="width: 100%;" v-model="condition">
                <a-select-option
                        v-for="option in options.condition"
                        :value="option.dataValue"
                >{{ option.dataValue }}</a-select-option>
            </a-select>
        </a-col>
        <a-col :span="7" class="ml4" v-if="flName">
            <a-input v-if="targetFlnameObj.dataType == 'TEXT' || targetFlnameObj.dataType == null" size="small" placeholder="search Text" style="width: 100%;" v-model="searchVal"/>
            <a-select v-if="targetFlnameObj.dataType == 'Dropdown'" size="small" style="width: 100%" v-model="searchVal">
                <a-select-option v-for="item in dropdownList == null ? [] : dropdownList" :value="item.code">{{item.codeDesc}}</a-select-option>
            </a-select>
            <a-date-picker v-if="targetFlnameObj.dataType == 'Date'"  size="small" format="YYYY-MM-DD" v-model="searchVal"/>
            <a-date-picker v-if="targetFlnameObj.dataType == 'Datetime(00:00:00)' || targetFlnameObj.dataType == 'Datetime'"  size="small" format="YYYY-MM-DD HH:mm:ss" :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" v-model="searchVal"/>
            <a-date-picker v-if="targetFlnameObj.dataType == 'Datetime(23:59:59)'"  size="small" format="YYYY-MM-DD HH:mm:ss" :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" v-model="searchVal"/>
        </a-col>
        <a-col class="ml4" :span="2">
            <!-- <a-tooltip placement="top"> -->
            <!-- <template slot="title">
                <span>Delete</span>
            </template>
            <img class="sbxs ml4"  src="../../../assets/img/ss-delete.png"  width="22" height="22"  > -->



            <a-popconfirm
                    :title="$t('generic.AreyoudeleTask')"
                    :okText="$t('generic.Yes')"
                    :cancelText="$t('generic.No')"
                    @confirm="deleteSelf"
            >
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{ $t('generic.Delete') }}</span>
                    </template>
                    <img class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22" style="margin-left: 4px">
                </a-tooltip>
            </a-popconfirm>


            <!-- </a-tooltip> -->
        </a-col>

    </a-row>
</template>
<script>
    import moment from 'moment'
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    export default{
        props:{
            options: {
                type: Object,
                default: function() {
                    return {};
                }
            },
        },
        data(){
            return{
                flName: null,
                condition: null,
                dataType:null,
                fieldName:null,
                searchVal: null,
                targetFlnameObj:{},
                dropdownList: []
            }
        },


        methods:{
            moment,
            deleteSelf() {
                this.$emit("delete-rule");
            },
            queryFormStatus(){

                if(this.fieldName==null || this.dataType==null){
                    this.fieldName=this.targetFlnameObj.fieldName
                    this.dataType=this.targetFlnameObj.dataType
                }

                let params = {
                    uid:  this.flName,
                    dataType:this.dataType,
                    condition: this.condition,
                    fieldName:this.fieldName
                }
                if(this.targetFlnameObj.dataType == 'Date'){
                    params.value =   moment( this.searchVal).format('YYYY-MM-DD')
                }else if(this.targetFlnameObj.dataType == 'Datetime(00:00:00)'){
                    params.value  = moment( this.searchVal).format('YYYY-MM-DD HH:mm:ss')
                }else if(this.targetFlnameObj.dataType == 'Datetime(23:59:59)'){
                    params.value  = moment( this.searchVal).format('YYYY-MM-DD HH:mm:ss')
                }else{
                    params.value = this.searchVal;
                }

                return params;
            },
            fillRuleStatus(data){
                this.flName = data.uid
                this.condition = data.condition
                this.searchVal = data.value
                if(data.fieldName!=null && data.dataType!=null){
                    this.fieldName=data.fieldName
                    this.dataType=data.dataType
                }
                this.flNameChange(this.flName)
            },
            flNameChange(item){
                let fieldNameSel = this.options.fieldNameSel
                for(let i in fieldNameSel){
                    if(fieldNameSel[i].uid == item){
                        this.targetFlnameObj = fieldNameSel[i]
                        if (this.targetFlnameObj.dataType == 'Dropdown') {
                            this.dropdownList = []
                            this.loadDropdownList(this.targetFlnameObj.uid)
                        }
                    }
                }

                if(this.targetFlnameObj.condition!=undefined){
                    this.condition = this.targetFlnameObj.condition
                }
            },
            // 获取下拉列表数据
            loadDropdownList(uid){
                // 根据uid获取T_GE_RT_SQL_COND.CODE_MASTER, 在T_CODE_MAST表中根据code_group获取配置的code
                ajax.get(api.REPORTGENERICCONDDATATYPEDROPDOWN,{uid: uid}).then(res=>{
                    this.dropdownList = res.data
                })
            }
        }
    }
</script>